// extracted by mini-css-extract-plugin
export var typingIndicator = "_oh-0";